import { BasePageModel } from 'models/BasePageModel';
import { PageState } from 'models/PageState';

/**
 * Takes a selector and adds currentpage as argument.
 * Replacing `useSelector(({currentPage}: PageState) => someSelector(currentPage))`
 * with
 * `useSelector(withCurrentPage(someSelector))`
 */
export const withCurrentPage =
  <T>(fn: (currentPage: BasePageModel) => T) =>
  ({ currentPage }: PageState) =>
    fn(currentPage);

/**
 * Returns the selected state from currentPage
 * @param {function} guard - page type guard
 * @param {function} selector - state selector
 * @returns selected state, or null if type guard failed
 */
export const withPage =
  <T, P extends BasePageModel>(
    guard: (currentPage: BasePageModel) => currentPage is P,
    selector: (currentPage: P) => T
  ) =>
  ({ currentPage }: PageState) =>
    guard(currentPage) ? selector(currentPage) : null;
